// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Fechamentos_RecalcularResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response Contract for /fechamentos/recalcular
 *
 * POST /fechamentos/recalcular/{id}
 *
 * Returns the recalculated valor_realizado for a fechamento
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Fechamentos_RecalcularResponseDados {
id: number
valor_realizado: number
}

export type Fechamentos_RecalcularResponse = ApiResponse<Fechamentos_RecalcularResponseDados>;

registerResponseContract('Fechamentos_RecalcularResponse', {
  id:              { type: 'number',  required: true },
  valor_realizado: { type: 'number',  required: true },
})
